import { PlainDropdownSimplified } from 'app/common/ui-next/plain-dropdown'

import styles from './DishesTableUnit.module.scss'
import { useState } from 'react'

const items = [
  { id: 'гр.', title: 'гр.' },
  { id: 'шт.', title: 'шт.' },
]

export const DishesTableUnit = ({
  locked,
  value,
  onChange,
}: {
  locked?: boolean
  value: string
  onChange: (value: string) => Promise<void>
}) => {
  const [disabled, setDisabled] = useState(false)

  const handleChange = async (value: string) => {
    setDisabled(true)
    await onChange(value)
    setDisabled(false)
  }

  if (locked) return <span>{value}</span>
  return (
    <PlainDropdownSimplified
      id="unit"
      items={items}
      value={value}
      onChange={handleChange}
      disabled={disabled}
      className={styles.dropdown}
      itemsContainerClassName={styles.dropdownItems}
    />
  )
}
